import { black, colors, ranges } from '../utils/common';
import styles from './legend.module.css';

const Legend = () => {
  return (
    <div className={styles.myLegend}>
      <div className={styles.legendTitle}>Suffer score</div>
      <div className={styles.legendScale}>
        <ul className={styles.legendLabels}>
          {colors.map((color, index) => {
            return (
              <li key={index}>
                <span style={{ background: color }}></span>
                {`${ranges[index][0]} - ${ranges[index][1]}`}
              </li>
            );
          })}
          <li>
            <span style={{ background: black }}></span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Legend;
